import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularFireModule, FIREBASE_OPTIONS } from '@angular/fire/compat';
import {
  AngularFireAnalyticsModule,
  APP_NAME,
  APP_VERSION,
  ScreenTrackingService,
  UserTrackingService,
} from '@angular/fire/compat/analytics';
import { AngularFirePerformanceModule, PerformanceMonitoringService } from '@angular/fire/compat/performance';
import {
  AngularFireRemoteConfig,
  AngularFireRemoteConfigModule,
  DEFAULTS,
  SETTINGS,
} from '@angular/fire/compat/remote-config';
import { VERSION } from 'src/app/version';
import { FirebaseOptions } from 'firebase/app';

const firebaseOptions: FirebaseOptions = {
  apiKey: 'AIzaSyDGBhYc6bqRLDHqO1-cG7_NOBfCiwa0S3w',
  authDomain: 'casanova-176411.firebaseapp.com',
  databaseURL: 'https://casanova-176411.firebaseio.com',
  projectId: 'casanova-176411',
  storageBucket: 'casanova-176411.appspot.com',
  messagingSenderId: '396484719089',
  appId: '1:396484719089:web:6a6f92095cd12ae0425450',
  measurementId: 'G-HB94GZBWBD',
};

const firebaseRemoteConfigDefaults = {
  test: 'test-default-value',
};

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AngularFireModule,
    AngularFireAnalyticsModule,
    AngularFirePerformanceModule,
    AngularFireRemoteConfigModule,
  ],
  providers: [
    {
      provide: FIREBASE_OPTIONS,
      useValue: firebaseOptions,
    },
    {
      provide: APP_NAME,
      useValue: 'lotto-admin-ui',
    },
    {
      provide: APP_VERSION,
      useValue: VERSION,
    },
    ScreenTrackingService,
    UserTrackingService,
    PerformanceMonitoringService,
    {
      provide: DEFAULTS,
      useValue: firebaseRemoteConfigDefaults,
    },
    {
      provide: SETTINGS,
      useValue: {
        minimumFetchIntervalMillis: 43200000,
        fetchTimeoutMillis: 60000,
      },
    },
    AngularFireRemoteConfig,
  ],
})
export class FirebaseModule {
  constructor(firebaseRemoteConfig: AngularFireRemoteConfig) {
    this.activateRemoteConfig(firebaseRemoteConfig);
  }

  private async activateRemoteConfig(firebaseRemoteConfig: AngularFireRemoteConfig) {
    await firebaseRemoteConfig.activate(); // activate previously fetched values
    firebaseRemoteConfig.fetch(); // fetch for next time
  }
}
